export const CARD_HEIGHT = '18.625rem';
export const DASHBOARD_GRID_WIDTH_MARGINS = 'w-full mb-4';
export const EXPIRING_SOON_DAYS = 60;

// Provider category IDs for which employment gaps are flagged on the dashboard.
// ID 1 = Physicians, ID 2 = Advanced Practice Providers (PAs, NPs, CNPs).
export const EMPLOYMENT_GAP_CATEGORY_IDS: number[] = [1, 2];

// Provider category IDs for which clinical privileges apply. Nurses and other
// non-clinical-privilege-holding categories do not see the Privileges card.
export const PRIVILEGES_APPLICABLE_CATEGORY_IDS: number[] = [1, 2];

export const isPrivilegesApplicable = (categoryId: number | null | undefined): boolean =>
  categoryId != null && PRIVILEGES_APPLICABLE_CATEGORY_IDS.includes(categoryId);
